import React, {FC, useState, ReactNode} from "react"
import {Row} from "react-bootstrap"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import {Checkbox} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import {H2} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {Img} from "./styled"

interface Props {
  title: string
  children: ReactNode
  img: string
  onButtonClick: () => void
  buttonText?: string
  checkboxText?: string
  applyBorder?: boolean
}

const SetupStep: FC<Props> = ({
  children,
  title,
  img,
  onButtonClick,
  buttonText = "platform.button.continue",
  checkboxText,
  applyBorder
}) => {
  const [isChecked, setIsChecked] = useState<boolean>(false)
  const theme = useTheme()

  return (
    <Flex gap={theme.spacing.five}>
      <div>
        <H2 marginBottom={2}>
          <FormattedMessage id={title} />
        </H2>
        {children}
        {checkboxText && (
          <Row>
            <Checkbox
              name="setupStepCheckbox"
              validation={Validation.bool().oneOf([true], "platform.defaultValidation.required")}
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}>
              <FormattedMessage id={checkboxText} />
            </Checkbox>
          </Row>
        )}
        {(!checkboxText || isChecked) && (
          <Button primary onClick={onButtonClick} marginTop={4}>
            <FormattedMessage id={buttonText} />
          </Button>
        )}
      </div>
      <Img src={img} applyBorder={applyBorder} />
    </Flex>
  )
}

export default SetupStep
